// extracted by mini-css-extract-plugin
module.exports = {"mediumInput":"styles_mediumInput__aXZbU"};